// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0bff9f01","453":"7ce275a5"}[chunkId] + ".chunk.js";
};